import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import hexToRgba from 'hex-rgba';
import { color } from '../../app/theme';
import Button from '../shared/Button';

const useStyles = makeStyles(
  () => ({
    root: {},
    paper: {
      width: 960,
      maxWidth: 'unset',
      borderRadius: 12,
      boxShadow:
        '0 30px 66px 0 rgba(0, 0, 0, 0.09), 0 8px 58px 0 rgba(0, 0, 0, 0.05)',
    },
    title: {
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      '& > h2': {
        fontSize: '17px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1',
        letterSpacing: 'normal',
        color: color.$3,
      },
      padding: '24px 24px 16px 24px',
      backgroundColor: '#f9f9f9',
    },
    content: {
      fontSize: '15px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: hexToRgba(color.$3, 60),
      padding: '0 24px 12px 24px',
      backgroundColor: '#f9f9f9',
    },
    actions: {
      padding: '12px 24px 24px',
      backgroundColor: '#f9f9f9',
    },
  }),
  {
    name: 'DialogText',
  },
);

function DialogText({
  isOpen,
  title,
  content,
  actions,
  cancelText,
  submitText,
  onCancel,
  onClick,
  isSubmitDisabled,
  isCancelHidden,
  isSubmitLoading,
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      className={classes.root}
      classes={{
        paper: classes.paper,
      }}
      open={isOpen}
    >
      <DialogTitle className={classes.title}>{title}</DialogTitle>
      <DialogContent className={classes.content}>{content}</DialogContent>
      <DialogActions className={classes.actions}>
        {actions || (
          <>
            {!isCancelHidden && (
              <Button
                topic="primaryBlue"
                onClick={onCancel}
                isDisable={isSubmitLoading}
              >
                {cancelText || t('modal.cancel')}
              </Button>
            )}
            <Button
              topic={!isCancelHidden ? 'primaryBlueHighLight' : 'primaryBlue'}
              onClick={onClick}
              isDisable={isSubmitDisabled || isSubmitLoading}
              isLoading={isSubmitLoading}
            >
              {submitText || t('modal.submit')}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}

DialogText.defaultProps = {
  actions: undefined,
  cancelText: undefined,
  submitText: undefined,
  isSubmitDisabled: false,
  isCancelHidden: false,
  onCancel: () => {},
  onClick: () => {},
  isSubmitLoading: false,
};

DialogText.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  actions: PropTypes.element,
  cancelText: PropTypes.string,
  submitText: PropTypes.string,
  onCancel: PropTypes.func,
  onClick: PropTypes.func,
  isSubmitDisabled: PropTypes.bool,
  isCancelHidden: PropTypes.bool,
  isSubmitLoading: PropTypes.bool,
};

export default DialogText;
